import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

export default connect(
  state => ({
    locale: state.i18n.locale,
    messages: state.i18n.messages,
    key: state.i18n.locale
  })
)(IntlProvider);



// WEBPACK FOOTER //
// ./src/components/i18n/i18n.js